import * as actionTypes from '../actions/actionTypes';
import {
  updateObject
} from '../../shared/utility';

const initialState = {
  devicesList: [],
  account: null,
  devices: null,
  error: false,
  refresh: false,
  errorStatus: null,
  success: false,
  loading: false,
  loaded: false,
  realDevices: null,
  paused: null,
  externalPorts: [],
  radioInfo: [],
  advancedDeviceSpinner: [],
  devicesByEquipment: null,
  advancedIdsLoaded: false,
  advancedIdsLoading: false,
  selectedActivityDeviceDetails: {},
  withPortForwarding: false,
};

const resetDevicesState = (state, action) => {
  return updateObject(state, initialState)
}
const initDevicesStart = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: true,
    loaded: false,
    devicesByEquipment: null,
    errorStatus: null,
    refresh: false
  });
};

const setDevices = (state, action) => {
  return updateObject(state, {
    realDevices: action.realDevices,
    externalPorts: action.externalPorts,
    radioInfo: action.radioInfo,
    loading: false,
    loaded: true,
    added: false,
    edited: false,
    errorStatus: null
  });
};
const setDevicesByEquipment = (state, action) => {
  // console.log("setDevicesByEquipment reducers", action.selectedEquipment);
  let equipId = typeof action.selectedEquipment === 'object' ? (action.selectedEquipment.podId ? action.selectedEquipment.podId : action.selectedEquipment.routerId) : null
  let newState = {}
  // console.log('equip id', equipId);
  // console.log('state:::::', state);
  //    if((equipId === null) && 
  //     state.devicesByEquipment !== null && state.devicesByEquipment.length > 0
  //     && state.devicesByEquipment.length !== state.realDevices.length){
  //    equipId = state.devicesByEquipment[0].leafToRoot[0].id;
  //  }
  if (equipId && state.realDevices) {
    if (equipId === null &&
      state.devicesByEquipment !== null && state.devicesByEquipment.length > 0
      && state.devicesByEquipment.length !== state.realDevices.length) {
      equipId = state.devicesByEquipment[0].leafToRoot[0].id;
    }
    // if(equipId && action.devicesByEquipment ){
    //   let devicesByEquipment = action.devicesByEquipment.filter((device, index) => {
    //     if (device.leafToRoot && device.leafToRoot.length && device.leafToRoot[0].id.toLowerCase() === equipId.toLowerCase()) {
    //       return device
    //     }
    // })
    newState = {
      // devicesByEquipment: devicesByEquipment
      ...state,
      devicesByEquipment: [
        ...state.realDevices.filter((device, index) => {
          return (device.leafToRoot && device.leafToRoot.length && device.leafToRoot[0].id.toLowerCase() === equipId.toLowerCase());
        })
      ],
    };

    return updateObject(state, newState);

  } else {
    return updateObject(state, {
      devicesByEquipment: state.realDevices,
    });
  }

};
const getAdvancedDeviceStart = (state, action) => {
  let newAdvancedDeviceSpinner = state.advancedDeviceSpinner.concat(action.deviceMac)
  return updateObject(state, {
    advancedDeviceSpinner: newAdvancedDeviceSpinner,
  });
};
const getAdvancedIdsStart = (state, action) => {
  return updateObject(state, {
    advancedIdsLoaded: false,
    advancedIdsLoading: true
  });
};
const setAdvancedDevice = (state, action) => {
  // console.log('setting advanced device', action.advancedDevice)

  let newState = {
    ...state,
    realDevices: [
      ...state.realDevices.map((device, index) => {
        if (device.mac === action.advancedDevice.deviceMac) {
          device.advancedDevice = action.advancedDevice
        }
        return device
      })
    ],
    devicesByEquipment: [
      ...state.devicesByEquipment.map((device, index) => {
        if (device.mac === action.advancedDevice.deviceMac) {
          device.advancedDevice = action.advancedDevice
        }
        return device
      })
    ],
    advancedDeviceSpinner: [
      ...state.advancedDeviceSpinner.slice(0, state.advancedDeviceSpinner.indexOf(action.advancedDevice.deviceMac))
    ]
  };


  return updateObject(newState, {});

};

const setAdvancedDeviceIds = (state, action) => {
  let advancedDeviceIds = state.advancedDeviceIds || {};
  // console.log('existing adids', advancedDeviceIds);
  // console.log('new adids', action.advancedDeviceIds);
  if (action.advancedDeviceIds) {
    for (var deviceMac in action.advancedDeviceIds) {
      advancedDeviceIds[deviceMac] = action.advancedDeviceIds[deviceMac];
    };
  }
  // console.log('updated adid', advancedDeviceIds);
  return updateObject(state, {
    advancedDeviceIds: advancedDeviceIds,
    advancedIdsLoaded: true,
    advancedIdsLoading: false
  });
};

const fetchDevicesFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    loaded: true,
    error: true,
    errorStatus: action.errorStatus,
    refresh: action.refresh
  });
};
const changeDevicesFailed = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: true
  });
};

const changeDevicesSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    success: true
  });
};
const resetDevicesErrorSuccess = (state, action) => {
  return updateObject(state, {
    success: false,
    error: false,
    refresh: false
  });
};

const reportAdidIssueFailed = (state, action) => {
  return updateObject(state, {
    reportAdidIssueError: true
  });
};

const reportAdidIssueSuccess = (state, action) => {
  return updateObject(state, {
    reportAdidIssueSuccess: true
  });
};

const resetAdidIssueErrorSuccess = (state, action) => {
  return updateObject(state, {
    reportAdidIssueSuccess: false,
    reportAdidIssueError: false
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INIT_DEVICES_START:
      return initDevicesStart(state, action);
    case actionTypes.SET_DEVICES:
      return setDevices(state, action);
    case actionTypes.SET_DEVICES_BY_EQUIPMENT:
      return setDevicesByEquipment(state, action);
    case actionTypes.FETCH_DEVICES_FAILED:
      return fetchDevicesFailed(state, action);
    case actionTypes.CHANGE_DEVICES_SUCCESS:
      return changeDevicesSuccess(state, action);
    case actionTypes.CHANGE_DEVICES_FAILED:
      return changeDevicesFailed(state, action);
    case actionTypes.RESET_DEVICES_ERROR_SUCCESS:
      return resetDevicesErrorSuccess(state, action);
    case actionTypes.SET_ADVANCED_DEVICE:
      return setAdvancedDevice(state, action);
    case actionTypes.GET_ADVANCED_DEVICE_START:
      return getAdvancedDeviceStart(state, action);
    case actionTypes.GET_ADVANCED_IDS_START:
      return getAdvancedIdsStart(state, action);
    case actionTypes.SET_SELECTED_EQUIPMENT:
      return setDevicesByEquipment(state, action);
    case actionTypes.SET_ADVANCED_DEVICE_IDS:
      return setAdvancedDeviceIds(state, action);
    case actionTypes.REPORT_ADID_ISSUE_SUCCESS:
      return reportAdidIssueSuccess(state, action);
    case actionTypes.REPORT_ADID_ISSUE_FAILED:
      return reportAdidIssueFailed(state, action);
    case actionTypes.RESET_ADID_ISSUE_ERROR_SUCCESS:
      return resetAdidIssueErrorSuccess(state, action);
    case actionTypes.ACTIVITY_SELECTED_DEVICE_DETAILS:
      return updateObject(state, {
        selectedActivityDeviceDetails: action.deviceDetails
      })
    default:
      return state;
  }
};

export default reducer;
